import Route from './Route';

export default {
    root: new Route('/'),
    organization: new Route('/organization/:organizationId'),
    organizationBuckets: new Route('/organization/:organizationId'),
    organizationMembers: new Route('/organization/:organizationId/members'),
    organizationReport: new Route('/organization/:organizationId/report'),
    organizationReportQuery: new Route(
        '/organization/:organizationId/report?start=:start&end=:end',
    ),
    bucket: new Route('/organization/:organizationId/bucket/:bucketId'),
    bucketMembers: new Route(
        '/organization/:organizationId/bucket/:bucketId/members',
    ),
    bucketAssets: new Route(
        '/organization/:organizationId/bucket/:bucketId/assets/:application',
    ),
};



// WEBPACK FOOTER //
// ./src/helpers/ApplicationRoutes.js